/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlFamilyProTemplateFieldsFragment = {
  __typename: "FamilyProTemplate";
  inviteTemplate?: string | null;
};

export const FamilyProTemplateFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "familyProTemplateFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FamilyProTemplate" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "inviteTemplate" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GqlFamilyProTemplateFieldsFragment, unknown>;
